<template>
    <div>
        <div class="page-header card">
            <div class="row align-items-end">
                <div class="col-lg-12">
                    <under-bar-name title="Chýbajúce faktúry" :margin="false"></under-bar-name>
                </div>
            </div>
        </div>

        <div class="pcoded-inner-content">
            <div class="main-body">
                <div class="page-wrapper">
                    <div class="page-body">

                        <!-- Date range + scan -->
                        <div class="card mb-4">
                            <div class="card-block p-4">
                                <h5 class="mb-4" style="font-weight: 600">Skenovať chýbajúce faktúry</h5>
                                <div class="row align-items-end">
                                    <div class="col-md-3 mb-3">
                                        <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 mb-1">Od</label>
                                        <input v-model="fromDate" type="date" class="form-control" />
                                    </div>
                                    <div class="col-md-3 mb-3">
                                        <label class="font-roboto font-bold text-12px tracking-0.1em uppercase text-#9598A7 mb-1">Do</label>
                                        <input v-model="toDate" type="date" class="form-control" />
                                    </div>
                                    <div class="col-md-3 mb-3">
                                        <button @click="scan" :disabled="scanning" class="btn btn-primary px-4" style="height: 40px; min-width: 140px">
                                            <span v-if="scanning">Skenujem...</span>
                                            <span v-else>Skenovať</span>
                                        </button>
                                    </div>
                                </div>
                                <div v-if="scanError" class="alert alert-danger py-2 px-3 mb-0" style="font-size: 13px">{{ scanError }}</div>
                            </div>
                        </div>

                        <!-- Results -->
                        <div v-if="scanned" class="card">
                            <div class="card-block">
                                <div class="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
                                    <h5 style="font-weight: 600; margin: 0">
                                        Chýbajúce faktúry
                                        <span class="badge badge-danger ml-2" v-if="results.length > 0">{{ results.length }}</span>
                                    </h5>
                                </div>

                                <div v-if="results.length === 0" class="text-center text-muted py-5">
                                    Žiadne chýbajúce faktúry za zvolené obdobie.
                                </div>

                                <div v-else class="table-responsive">
                                    <table class="table table-hover" style="margin-bottom: 0">
                                        <thead>
                                            <tr>
                                                <th>Stripe číslo</th>
                                                <th>Stripe ID</th>
                                                <th>Email</th>
                                                <th>User ID</th>
                                                <th>Suma</th>
                                                <th>Dátum</th>
                                                <th>Billing reason</th>
                                                <th>Akcie</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="inv in results" :key="inv.stripe_invoice_id" :class="{ 'table-success': inv.created, 'table-danger': inv.error }">
                                                <td><h6>{{ inv.stripe_invoice_number || '-' }}</h6></td>
                                                <td><code style="font-size: 11px">{{ inv.stripe_invoice_id }}</code></td>
                                                <td><h6>{{ inv.user_email || inv.customer_email || '-' }}</h6></td>
                                                <td><h6>{{ inv.user_id }}</h6></td>
                                                <td><h6>{{ inv.amount }} {{ inv.currency }}</h6></td>
                                                <td><h6>{{ formatDate(inv.created_at) }}</h6></td>
                                                <td><small class="text-muted">{{ inv.billing_reason }}</small></td>
                                                <td>
                                                    <div class="d-flex align-items-center" style="gap: 8px; flex-wrap: wrap">
                                                        <a :href="inv.stripe_link" target="_blank" class="btn btn-sm btn-outline-secondary">Stripe</a>
                                                        <button
                                                            v-if="!inv.created"
                                                            @click="createInvoice(inv)"
                                                            :disabled="inv.creating"
                                                            class="btn btn-sm btn-primary"
                                                        >
                                                            <span v-if="inv.creating">...</span>
                                                            <span v-else>Vytvoriť</span>
                                                        </button>
                                                        <span v-if="inv.created" class="text-success" style="font-size: 12px; font-weight: 600">&#10003; Vytvorená</span>
                                                        <span v-if="inv.error" class="text-danger" style="font-size: 11px">{{ inv.error }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        const today = new Date()
        const firstOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
        return {
            fromDate: firstOfLastMonth.toISOString().substring(0, 10),
            toDate: today.toISOString().substring(0, 10),
            scanning: false,
            scanned: false,
            scanError: null,
            results: [],
        }
    },
    methods: {
        scan() {
            this.scanning = true
            this.scanError = null
            this.scanned = false
            this.results = []
            axios.get('/api/admin/invoices/missing', {
                params: { from: this.fromDate, to: this.toDate }
            })
                .then(response => {
                    this.results = response.data.map(inv => ({
                        ...inv,
                        creating: false,
                        created: false,
                        error: null,
                    }))
                    this.scanned = true
                })
                .catch(error => {
                    const msg = error.response?.data?.message
                        || Object.values(error.response?.data?.errors || {}).flat().join(' ')
                        || 'Nastala chyba pri skenovaní'
                    this.scanError = typeof msg === 'string' ? msg : 'Nastala chyba'
                })
                .finally(() => { this.scanning = false })
        },
        createInvoice(inv) {
            inv.creating = true
            inv.error = null
            axios.post('/api/admin/invoice/create', {
                user_id: inv.user_id,
                stripe_invoice_id: inv.stripe_invoice_id,
                date: this.formatDateInput(inv.created_at),
            })
                .then(() => {
                    inv.created = true
                })
                .catch(error => {
                    const msg = error.response?.data?.message
                        || Object.values(error.response?.data?.errors || {}).flat().join(' ')
                        || 'Chyba pri vytváraní'
                    inv.error = typeof msg === 'string' ? msg : 'Chyba'
                })
                .finally(() => { inv.creating = false })
        },
        formatDate(ts) {
            if (!ts) return '-'
            return new Date(ts * 1000).toLocaleDateString('sk-SK')
        },
        formatDateInput(ts) {
            if (!ts) return null
            return new Date(ts * 1000).toISOString().substring(0, 10)
        },
    },
}
</script>
